import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Liability } from '../../models/liability.model';
import { DEFAULT_PATTERN_WITH_TIME } from '../../../shared/configs/date-config';
import { AppConfig } from '../../../core/services/app-config.service';

@Component({
standalone: false,
  selector: 'app-fill-amount-dialog',
  styleUrls: ['./fill-amount-dialog.component.scss'],
  templateUrl: './fill-amount-dialog.component.html',
})
export class FillAmountDialogComponent implements OnInit {
  public amount: FormControl;
  public MIN_AMOUNT = 0.01;

  public defaultPatternWithTime: string = DEFAULT_PATTERN_WITH_TIME;

  constructor(
    @Inject(MAT_DIALOG_DATA) public liability: Liability,
    private dialogRef: MatDialogRef<FillAmountDialogComponent>,
    public appConfig: AppConfig,
  ) {}

  public ngOnInit(): void {
    this.amount = new FormControl(this.liability.amount, [
      Validators.required,
      Validators.max(this.appConfig.config.liabilityAmountLimit),
      Validators.min(this.MIN_AMOUNT),
    ]);
  }

  public save(): void {
    if (this.amount.valid) {
      this.dialogRef.close({ amount: this.amount.value });
    }
  }
}

export interface FillAmountDialogResult {
  amount: number;
}
